const VuexTypes = Object.freeze({
  LOGIN: 'LOGIN',
  LOAD_USER_INFO: 'LOAD_USER_INFO',
  LOGOUT: 'LOGOUT',
  UPDATE_TOKEN: 'UPDATE_TOKEN',
  SET_INFO: 'SET_INFO',
  SET_TOKEN: 'SET_TOKEN',
  REGISTER: 'REGISTER',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD'
});

export default VuexTypes;
